import useSWR from 'swr';
import { GetUserComplianceSettingsResponse } from '@thera-hr/api-sdk/api/resources/api/resources/thera/resources/user';

import { globalFetcherSettings } from 'lib/constants';
import { useTheraFernClient } from './useFern';

export default function useContractorCompliance(companyID: string, identifier: string) {
  const { theraFernApi } = useTheraFernClient();

  const getUserComplianceSettingsFetcher = async (): Promise<GetUserComplianceSettingsResponse> => {
    // Determine if the identifier is an email or a userId
    const isEmail = identifier?.includes('@');
    const params = isEmail ? { email: identifier } : { userId: identifier };
    const response = await theraFernApi.thera.user.userApi.getComplianceUserSetting(companyID, params);
    return response;
  };

  const { data, mutate, isLoading } = useSWR(
    () => (!identifier || !companyID ? false : ['getUserComplianceSettingsFetcher', identifier, companyID]),
    getUserComplianceSettingsFetcher,
    {
      ...globalFetcherSettings,
      onErrorRetry: (error) => {
        if (error.status === 404) return;
      },
      keepPreviousData: false,
    },
  );

  /**
   * the API throws 404 to indicate non-existence of a user, so data should be null when that happens
   */
  const _data = isLoading ? undefined : data || null;

  return {
    kycAndComplianceInfo: _data,
    mutate,
    isPending: isLoading,
  };
}
